import axios from 'axios';
import { JAVA_BACKEND_USER_PASS, JAVA_BACKEND_API_URL, getAuthHeader } from '../Components/Contexts/BackendConstants';

// API Base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://gw.sakagrup.com:8443';
const STAND_API = `${API_BASE_URL}/api/v1/stand`;
const FIRMA_API = `${API_BASE_URL}/api/v1/firma`;

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const headers = {
    // #429: the shared constant, not a copy of the credential
    'Authorization': `Basic ${btoa(JAVA_BACKEND_USER_PASS)}`,
    'X-User-Id': userId,
    'Content-Type': 'application/json'
  };

  if (token) {
    headers['X-Token'] = token;
  }

  return headers;
};

// ─── Mock Stand List ─────────────────────────────────────────────────────────
const mockStandList = [
  {
    standId: 57891,
    standName: '2.2A10',
    salonId: 2,
    salonName: '2',
    status: 'occupied',
    firmaId: 101,
    firmaName: 'RALFTEKS TEKS. GIDA TAR. URUN. INS. EMLAK SAN. VE TIC. AS.',
    decoratorFirmaId: 202,
    decoratorFirmaName: 'ZABUN GRUP - FIX EXPO',
    areaSquareMeters: 52,
    standType: 'Ozel Stand->Tek Katli->Sunta - MDF Lam',
    standHeight: '3.50m',
    mensei: 'Yerli',
    elektrikTalebi: 6,
    suTalebi: null,
    havaTalebi: 6,
    internetTalebi: 'Var',
    isIzinleriCount: '0/0',
    standDurumu: {
      suBorcu: false,
      havaBorcu: false,
      elektrikBorcu: false,
      alanBorcu: false,
      projeBorcu: false,
      problemliStand: 'hayir',
      icTesisat: 'yok',
      yasakliStand: 'hayir',
      islakImza: 'yok',
      camKullanimi: 'yok',
    },
    fuarId: 3,
  },
  {
    standId: 58135,
    standName: '2.2A100',
    salonId: 2,
    salonName: '2',
    status: 'occupied',
    firmaId: 102,
    firmaName: 'TAREK ALAADDIN ABDERLKADER MOHAMED RIAD',
    decoratorFirmaId: 202,
    decoratorFirmaName: 'ZABUN GRUP - FIX EXPO',
    areaSquareMeters: 36,
    standType: 'Ozel Stand->Tek Katli->Maxima Kare Profil',
    standHeight: '3.00m',
    mensei: 'Yerli',
    elektrikTalebi: 5,
    suTalebi: null,
    havaTalebi: 5,
    internetTalebi: 'Var',
    isIzinleriCount: '0/0',
    standDurumu: {
      suBorcu: false,
      havaBorcu: false,
      elektrikBorcu: false,
      alanBorcu: false,
      projeBorcu: false,
      problemliStand: 'hayir',
      icTesisat: 'yok',
      yasakliStand: 'hayir',
      islakImza: 'yok',
      camKullanimi: 'yok',
    },
    fuarId: 3,
  },
  {
    standId: 58137,
    standName: '2.2A105',
    salonId: 2,
    salonName: '2',
    status: 'reserved',
    firmaId: 103,
    firmaName: 'ITALIAN EXHIBITION GROUP USA, INC.',
    decoratorFirmaId: 202,
    decoratorFirmaName: 'ZABUN GRUP - FIX EXPO',
    areaSquareMeters: 40,
    standType: 'Ozel Stand->Tek Katli->Maxima Kare Profil',
    standHeight: '3.00m',
    mensei: 'Yabanci',
    elektrikTalebi: 5,
    suTalebi: null,
    havaTalebi: 5,
    internetTalebi: 'Var',
    isIzinleriCount: '0/0',
    standDurumu: {
      suBorcu: false,
      havaBorcu: false,
      elektrikBorcu: false,
      alanBorcu: false,
      projeBorcu: false,
      problemliStand: 'hayir',
      icTesisat: 'yok',
      yasakliStand: 'hayir',
      islakImza: 'yok',
      camKullanimi: 'yok',
    },
    fuarId: 3,
  },
  {
    standId: 58129,
    standName: '2.2A110',
    salonId: 2,
    salonName: '2',
    status: 'empty',
    firmaId: null,
    firmaName: null,
    decoratorFirmaId: null,
    decoratorFirmaName: null,
    areaSquareMeters: 25,
    standType: 'Ozel Stand->Tek Katli->Maxima Kare Profil',
    standHeight: '3.00m',
    mensei: null,
    elektrikTalebi: 0,
    suTalebi: null,
    havaTalebi: 0,
    internetTalebi: 'Yok',
    isIzinleriCount: '0/0',
    standDurumu: {
      suBorcu: false,
      havaBorcu: false,
      elektrikBorcu: false,
      alanBorcu: false,
      projeBorcu: false,
      problemliStand: 'hayir',
      icTesisat: 'yok',
      yasakliStand: 'hayir',
      islakImza: 'yok',
      camKullanimi: 'yok',
    },
    fuarId: 3,
  },
  {
    standId: 58200,
    standName: '1.A101',
    salonId: 1,
    salonName: '1',
    status: 'occupied',
    firmaId: 1,
    firmaName: 'NEHIR IS SAGLIGI VE GUVENLIGI',
    decoratorFirmaId: 203,
    decoratorFirmaName: 'ALFA DEKOR A.S.',
    areaSquareMeters: 50,
    standType: 'Ozel Stand->Iki Katli->Ahsap',
    standHeight: '4.00m',
    mensei: 'Yerli',
    elektrikTalebi: 10,
    suTalebi: 2,
    havaTalebi: 8,
    internetTalebi: 'Var',
    isIzinleriCount: '2/3',
    standDurumu: {
      suBorcu: false,
      havaBorcu: false,
      elektrikBorcu: false,
      alanBorcu: false,
      projeBorcu: true,
      problemliStand: 'hayir',
      icTesisat: 'var',
      yasakliStand: 'hayir',
      islakImza: 'var',
      camKullanimi: 'var',
    },
    fuarId: 3,
  },
];

// ─── Mock Stand Detail Data ───────────────────────────────────────────────────
const mockDetailExtras = {
  57891: {
    firmalar: [
      { firmaId: 101, firmaName: 'RALFTEKS TEKS. GIDA TAR. URUN. INS. EMLAK SAN. VE TIC. AS.', firmaTypeName: 'Katılımcı', eslesmeSeviyesi: 1 },
      { firmaId: 202, firmaName: 'ZABUN GRUP - FİX EXPO', firmaTypeName: 'Dekoratör', eslesmeSeviyesi: 1 },
    ],
    talepler: {
      elektrik: { talep: 6, borc: false },
      su: { talep: 0, borc: false },
      hava: { talep: 6, borc: false },
    },
    isIzinleri: [],
    dosyalar: [
      {
        id: 1,
        fileName: 'stand_projesi_2025.pdf',
        fileType: 'Proje',
        fileSize: '2.4 MB',
        uploadedBy: 'Ahmet Yilmaz',
        uploadedAt: '2025-01-15T10:30:00',
        fileUrl: '#',
      },
      {
        id: 2,
        fileName: 'kurulum_fotograf_01.jpg',
        fileType: 'Fotograf',
        fileSize: '1.1 MB',
        uploadedBy: 'Zeynep Demir',
        uploadedAt: '2025-01-20T14:00:00',
        fileUrl: '#',
      },
    ],
    projeGrubu: [
      {
        id: 1,
        standName: '2.2A10',
        firmaName: 'RALFTEKS TEKS.',
        decoratorName: 'ZABUN GRUP - FIX EXPO',
        projeType: 'Ozel Stand',
        standYuksekligi: '3.50m',
        projeDurumu: 'Onaylandi',
        anlasma: 'Imzalandi',
      },
    ],
    activityLog: [
      {
        id: 1,
        userName: 'Ahmet Yilmaz',
        description: 'Stand durumu guncellendi.',
        createdAt: '2025-01-20T10:00:00',
      },
      {
        id: 2,
        userName: 'Zeynep Demir',
        description: 'Firma eslesmesi yapildi: RALFTEKS TEKS.',
        createdAt: '2025-01-18T15:30:00',
      },
    ],
    krokiPlan: {
      alan: '52 m2',
      planImageUrl: null,
    },
  },
  58135: {
    firmalar: [
      { firmaId: 102, firmaName: 'TAREK ALAADDIN ABDERLKADER MOHAMED RIAD', firmaTypeName: 'Katilimci', eslesmeSeviyesi: 1 },
      { firmaId: 202, firmaName: 'ZABUN GRUP - FIX EXPO', firmaTypeName: 'Dekorator', eslesmeSeviyesi: 1 },
    ],
    talepler: {
      elektrik: { talep: 5, borc: false },
      su: { talep: 0, borc: false },
      hava: { talep: 5, borc: false },
    },
    isIzinleri: [],
    dosyalar: [],
    projeGrubu: [],
    activityLog: [
      {
        id: 1,
        userName: 'Mehmet Kaya',
        description: 'Stand olusturuldu.',
        createdAt: '2025-01-10T09:00:00',
      },
    ],
    krokiPlan: { alan: '36 m2', planImageUrl: null },
  },
};

// Default detail template for stands not in mockDetailExtras
const defaultDetail = (stand) => ({
  firmalar: stand.firmaId
    ? [{ firmaId: stand.firmaId, firmaName: stand.firmaName, firmaTypeName: 'Katilimci', eslesmeSeviyesi: 1 }]
    : [],
  talepler: {
    elektrik: { talep: stand.elektrikTalebi || 0, borc: false },
    su: { talep: stand.suTalebi || 0, borc: false },
    hava: { talep: stand.havaTalebi || 0, borc: false },
  },
  isIzinleri: [],
  dosyalar: [],
  projeGrubu: [],
  activityLog: [],
  krokiPlan: { alan: `${stand.areaSquareMeters || 0} m2`, planImageUrl: null },
});

// Mock firma listesi (firma eşleme modalı için)
const mockAllFirmalar = [
  { firmaId: 1,   firmaName: 'NEHIR IS SAGLIGI VE GUVENLIGI',   firmaTypeId: 1 },
  { firmaId: 4,   firmaName: 'TEST FIRMA',                       firmaTypeId: 1 },
  { firmaId: 101, firmaName: 'RALFTEKS TEKS. GIDA TAR.',         firmaTypeId: 1 },
  { firmaId: 102, firmaName: 'TAREK ALAADDIN ABDERLKADER',       firmaTypeId: 1 },
  { firmaId: 103, firmaName: 'ITALIAN EXHIBITION GROUP USA',     firmaTypeId: 1 },
  { firmaId: 202, firmaName: 'ZABUN GRUP - FIX EXPO',            firmaTypeId: 2 },
  { firmaId: 203, firmaName: 'ALFA DEKOR A.S.',                  firmaTypeId: 2 },
  { firmaId: 204, firmaName: 'MEGA DEKORASYON LTD.',             firmaTypeId: 2 },
  { firmaId: 301, firmaName: 'ISTANBUL FUAR HIZMETLERI',         firmaTypeId: 3 },
  { firmaId: 302, firmaName: 'GLOBAL FUAR ORGANIZASYON',         firmaTypeId: 3 },
];

// Use mock data flag
const USE_MOCK_DATA = false;

/**
 * Stand Service — Mock & Real API wrapper
 * Tüm metodlar USE_MOCK_DATA=true iken mock data döner,
 * false olunca gerçek backend endpoint'lerine istek atar.
 */
export const standService = {
  // ── GET api/v1/stand/list?fuarId=3&salonId=1&page=0&size=25 ──
  async getStandList(params = {}) {
    if (USE_MOCK_DATA) {
      const { fuarId, salonId = null, status = null, page = 0, size = 25, search = '' } = params;
      let filtered = mockStandList.filter((stand) => {
        if (fuarId && stand.fuarId !== parseInt(fuarId)) return false;
        if (salonId && stand.salonId !== parseInt(salonId)) return false;
        if (status && stand.status !== status) return false;
        if (search && !stand.standName.toLowerCase().includes(search.toLowerCase())) return false;
        return true;
      });
      const totalElements = filtered.length;
      const totalPages = Math.ceil(totalElements / size) || 1;
      const start = page * size;
      const paginatedData = filtered.slice(start, start + size);
      return {
        content: paginatedData,
        pageable: { pageNumber: page, pageSize: size, sort: { sorted: true, unsorted: false } },
        totalElements,
        totalPages,
        last: page >= totalPages - 1,
        first: page === 0,
        numberOfElements: paginatedData.length,
      };
    }
    const response = await axios.get(`${STAND_API}/list`, {
      params,
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── GET api/v1/stand/{id} ──
  async getStandDetail(standId) {
    if (USE_MOCK_DATA) {
      const stand = mockStandList.find((s) => s.standId === parseInt(standId));
      if (!stand) throw new Error('Stand bulunamadı');
      const extra = mockDetailExtras[stand.standId] || defaultDetail(stand);
      return { ...stand, ...extra };
    }
    const response = await axios.get(`${STAND_API}/${standId}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── PUT api/v1/stand/{id}/status ──
  async updateStandStatus(standId, statusData) {
    if (USE_MOCK_DATA) {
      const index = mockStandList.findIndex((s) => s.standId === parseInt(standId));
      if (index === -1) throw new Error('Stand bulunamadi');
      Object.assign(mockStandList[index], statusData);
      if (mockDetailExtras[standId]) {
        Object.assign(mockDetailExtras[standId], statusData);
      }
      return { ...mockStandList[index], ...statusData };
    }
    const response = await axios.put(`${STAND_API}/${standId}/status`, statusData, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── POST api/v1/stand/create ──
  async createStand(formData) {
    if (USE_MOCK_DATA) {
      const newStand = {
        standId: Date.now(),
        ...formData,
        status: formData.status || 'empty',
        fuarId: formData.fuarId || 3,
      };
      mockStandList.push(newStand);
      return newStand;
    }
    const response = await axios.post(`${STAND_API}/create`, formData, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── PUT api/v1/stand/{id} ──
  async updateStand(standId, payload) {
    if (USE_MOCK_DATA) {
      const index = mockStandList.findIndex((s) => s.standId === parseInt(standId));
      if (index === -1) throw new Error('Stand bulunamadı');
      Object.assign(mockStandList[index], payload);
      return mockStandList[index];
    }
    const response = await axios.put(`${STAND_API}/${standId}`, payload, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── DELETE api/v1/standTalep/delete/{standId} (#550) ──
  // WAS: DELETE api/v1/stand/{id} — the backend has no such mapping, so every delete from the staff pages failed. The real endpoint is a
  // SOFT delete (the stand leaves the lists, the row stays; the companies on it lose the fair role no other stand of the fair gives them),
  // staff with STAND_REQUEST_MANAGE (403 otherwise) or an organizer with STAND_SIL at the stand's fair.
  async deleteStand(standId) {
    if (USE_MOCK_DATA) {
      const index = mockStandList.findIndex((s) => s.standId === parseInt(standId));
      if (index !== -1) mockStandList.splice(index, 1);
      return true;
    }
    await axios.delete(`${JAVA_BACKEND_API_URL}/standTalep/delete/${standId}`, {
      headers: getAuthHeader()
    });
  },

  // ── DELETE api/v1/stand/{standId}/file/{fileId} ──
  async deleteStandFile(standId, fileId) {
    if (USE_MOCK_DATA) {
      if (mockDetailExtras[standId]) {
        mockDetailExtras[standId].dosyalar = mockDetailExtras[standId].dosyalar.filter(
          (f) => f.id !== fileId
        );
      }
      return true;
    }
    await axios.delete(`${STAND_API}/${standId}/file/${fileId}`, {
      headers: getAuthHeaders()
    });
  },

  // ── POST api/v1/stand/{standId}/file/upload ──
  async uploadStandFile(standId, file, fileTypeId) {
    if (USE_MOCK_DATA) {
      const newFile = {
        id: Date.now(),
        fileName: file.name,
        fileType: fileTypeId === 1 ? 'Proje' : fileTypeId === 2 ? 'Fotograf' : 'Diger',
        fileSize: `${(file.size / 1024 / 1024).toFixed(1)} MB`,
        uploadedBy: 'Kullanici',
        uploadedAt: new Date().toISOString(),
        fileUrl: '#',
      };
      if (mockDetailExtras[standId]) {
        mockDetailExtras[standId].dosyalar = [newFile, ...(mockDetailExtras[standId].dosyalar || [])];
      }
      return newFile;
    }
    const formData = new FormData();
    formData.append('file', file);
    if (fileTypeId) formData.append('fileTypeId', fileTypeId);
    const response = await axios.post(`${STAND_API}/${standId}/file/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...getAuthHeaders()
      },
    });
    return response.data;
  },

  // ── POST api/v1/firma/esle (stand ↔ firma mapping) ──
  async esleStandFirma({ standId, firmaId, fuarId, firmaTypeId, salonId, eslesmeSeviyesi }) {
    if (USE_MOCK_DATA) {
      const firma = mockAllFirmalar.find((f) => f.firmaId === parseInt(firmaId));
      if (!firma) throw new Error('Firma bulunamadi');
      const stand = mockStandList.find((s) => s.standId === parseInt(standId));
      if (stand && !stand.firmaId) {
        stand.firmaId = firma.firmaId;
        stand.firmaName = firma.firmaName;
        stand.status = 'reserved';
      }
      const newMapping = {
        firmaId: firma.firmaId,
        firmaName: firma.firmaName,
        firmaTypeName: firmaTypeId === 1 ? 'Katilimci' : firmaTypeId === 2 ? 'Dekorator' : 'Hizmet',
        eslesmeSeviyesi: eslesmeSeviyesi || 1,
      };
      if (mockDetailExtras[standId]) {
        const existing = mockDetailExtras[standId].firmalar.find((f) => f.firmaId === firma.firmaId);
        if (!existing) {
          mockDetailExtras[standId].firmalar.push(newMapping);
          mockDetailExtras[standId].activityLog.unshift({
            id: Date.now(),
            userName: 'Kullanici',
            description: `Firma eslesmesi yapildi: ${firma.firmaName}`,
            createdAt: new Date().toISOString(),
          });
        }
      }
      return newMapping;
    }
    const response = await axios.post(`${FIRMA_API}/esle`, {
      firmaId,
      fuarId,
      firmaTypeId,
      salonId,
      standId,
    }, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── DELETE firma mapping from stand ──
  async removeStandFirmaMapping(standId, firmaId, fuarId) {
    if (USE_MOCK_DATA) {
      if (mockDetailExtras[standId]) {
        mockDetailExtras[standId].firmalar = mockDetailExtras[standId].firmalar.filter(
          (f) => f.firmaId !== parseInt(firmaId)
        );
      }
      return true;
    }
    await axios.delete(`${FIRMA_API}/${firmaId}/fuar/${fuarId}/soft-delete`, {
      headers: getAuthHeaders()
    });
  },

  // ── GET api/v1/firma/getFirmaWithStands?fuarId=3 (firma eşleme modalı için) ──
  async getFirmaListForMapping(fuarId, search = '') {
    if (USE_MOCK_DATA) {
      let filtered = mockAllFirmalar;
      if (search) {
        filtered = filtered.filter((f) =>
          f.firmaName.toLowerCase().includes(search.toLowerCase())
        );
      }
      return filtered;
    }
    const response = await axios.get(`${FIRMA_API}/getFirmaWithStands`, {
      params: { fuarId, firmaName: search || undefined },
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── GET api/v1/stand/salon/{salonId}?fuarId=3 ──
  async getStandsBySalon(salonId, fuarId) {
    if (USE_MOCK_DATA) {
      return mockStandList.filter((s) => s.salonId === parseInt(salonId) && s.fuarId === parseInt(fuarId));
    }
    const response = await axios.get(`${STAND_API}/salon/${salonId}`, {
      params: { fuarId },
      headers: getAuthHeaders()
    });
    return response.data;
  },

  // ── GET api/v1/stand/stats?fuarId=3 ──
  async getStandStats(fuarId) {
    if (USE_MOCK_DATA) {
      const stands = mockStandList.filter((s) => s.fuarId === parseInt(fuarId));
      return {
        total: stands.length,
        empty: stands.filter((s) => s.status === 'empty').length,
        reserved: stands.filter((s) => s.status === 'reserved').length,
        occupied: stands.filter((s) => s.status === 'occupied').length,
      };
    }
    const response = await axios.get(`${STAND_API}/stats`, { params: { fuarId } });
    return response.data;
  },
};

